module.exports = __webpack_public_path__ + "img/van_der_Staay.cc015cab.png";